import { useMutation } from '@tanstack/react-query'

import { useInvalidateReferralLinksQueries } from '@/components/misc/ReferralLinksTable/hooks/useInvalidateReferralLinksQueries'
import useNotyf from '@/hooks/useNotyf'
import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import referralLinkService from '@/lib/services/referralLinkService'

export function useDeleteLinkMutation() {
  const showGenericServerError = useShowGenericServerError()
  const invalidateReferralLinksQueries = useInvalidateReferralLinksQueries()
  const notyf = useNotyf()

  return useMutation({
    mutationFn: (referralLinkId: number) =>
      referralLinkService.deleteReferralLink(referralLinkId),
    onSuccess: async () => {
      await invalidateReferralLinksQueries()

      notyf.success('Link deleted successfully')
    },
    onError: showGenericServerError,
  })
}
